import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FilterModel } from 'src/Models/filterModel';
import { SeminarsModel, SeminarsSectionsModel } from 'src/Models/SeminarsModel';
import { SeminarService } from 'src/Services/seminar.service';
import { CheckAuth } from 'src/Services/utility.service';

@Component({
  selector: 'app-front-seminar',
  templateUrl: './front-seminar.component.html',
  styleUrls: ['./front-seminar.component.css']
})
export class FrontSeminarComponent implements OnInit {
  listOfSeminars: SeminarsModel[];
  filterModel = new FilterModel();
  tokenKey: string = '';
  _userID: any;

  currentPage: number = 1;
  totalRecordCount: number = -1;
  keywordFilter: string = '';
  OrderBy: string = '';
  isAscending: boolean = false
  listOfSpecialReportSection: SeminarsSectionsModel[];
  groupArr: any[];
  seminarSectionDetails: any = [];
  isloading: boolean = false;

  constructor(private readonly seminarService: SeminarService,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title) {
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
    this._userID = sessionStorage.getItem('UserId');
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
    this.filterModel.orderBy = 'SortOrder';
    this.filterModel.userID = this._userID;
    this.titleService.setTitle('Seminars | JSi360');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.i360SeminarsGet();
  }

  i360SeminarsGet() {
    this.isloading = true;
    this.seminarService.i360SeminarsGetFront(this.tokenKey).subscribe(
      data => {
        this.isloading = false;
        this.listOfSeminars = data.listOfData;

        this.groupArr = this.listOfSeminars.reduce((r, { sectionName }) => {
          if (!r.some(o => o.sectionName == sectionName)) {
            r.push({ sectionName, groupItem: this.listOfSeminars.filter(v => v.sectionName == sectionName) });
          }
          return r;
        }, []);

        if (this.listOfSeminars != null) {
          if (this.listOfSeminars.length > 0) {
            this.totalRecordCount = this.listOfSeminars[0].totalRecordCount;
          }
          else {
            this.totalRecordCount = 0;
          }
        }
        else {
          this.totalRecordCount = 0;
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }
}
